import { IonContent, IonPage } from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import React from 'react'
import { useTranslation } from 'react-i18next'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import {
  addInsuranceInformation,
  clearInsuranceInformationData,
  setGroupname,
  setGroupNumber,
  setInsurancecarrier,
  setPolicy,
} from '../store/insuranceInformation.actions'
import InsuranceInformationContent from '../content/InsuranceInformation.content'
import { getInsuranceInformationStateSelector } from '../selectors'
import { hasUnsavedInsuranceData, showUnsavedDataWarningMessage } from '../../../utilities/unSavedData.util'
import { IRuleError } from '../../rules/store/rules.types'
import { InsuranceInformationConstants } from '../store/insuranceInformation.constants'
import { getRulesSelector } from '../../rules/selectors'

const InsuranceInformation: React.FC = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const insuranceInformationState = useSelector(getInsuranceInformationStateSelector)
  const { insuranceInformationData, insuranceInformationList } = insuranceInformationState
  const { insuranceCarrier } = insuranceInformationData
  const rulesState = useSelector(getRulesSelector)
  const { errors } = rulesState

  const onBackClickYes = () => {
    dispatch(setInsurancecarrier(''))
    dispatch(setGroupNumber(''))
    dispatch(setPolicy(''))
    dispatch(setGroupname(''))
    dispatch(clearInsuranceInformationData())
    history.push(TabConstants.BILLING)
  }

  const onBackClick = () => {
    if (hasUnsavedInsuranceData(insuranceInformationData, insuranceInformationList)) {
      showUnsavedDataWarningMessage(dispatch, t, t('insuranceInformation.unsavedDataWarningMessage'), onBackClickYes)
      return
    }
    onBackClickYes()
  }

  const onSaveClick = () => {
    const reduxActions: string[] = [
      InsuranceInformationConstants.SET_INSURANCE_CARRIER,
      InsuranceInformationConstants.SET_GROUP_NAME,
      InsuranceInformationConstants.SET_GROUP_NUMBER,
      InsuranceInformationConstants.SET_POLICY,
      'state_insuranceInformation/SET_INSURANCE_CARRIER',
      'state_insuranceInformation/SET_GROUP_NAME',
      'state_insuranceInformation/SET_GROUP_NUMBER',
      'state_insuranceInformation/SET_POLICY',
    ]
    const validationErrors = Object.values(errors)
      .flat()
      .filter((error: IRuleError) => reduxActions.includes(error.id) && error.reduxStateOnlyFlag)

    if (validationErrors.length) {
      alert('Please Correct Errors')
      return
    }

    if (insuranceCarrier) {
      dispatch(addInsuranceInformation())
      dispatch(setInsurancecarrier(''))
      dispatch(setGroupNumber(''))
      dispatch(setPolicy(''))
      dispatch(setGroupname(''))
    } else {
      alert('Insurance Carrier Required')
    }
  }

  return (
    <IonPage id='InsuranceInformationPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        isBackButton={true}
        nextLabel={t('common.buttons.Save')}
        nextOnClick={onSaveClick}
        title={t('insuranceInformation.InsuranceInformation')}
      />
      <IonContent color='light'>
        <InsuranceInformationContent />
      </IonContent>
    </IonPage>
  )
}

export default InsuranceInformation
